var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag || 'div',{tag:"div",staticClass:"polished card",class:{
        lower: _vm.lower,
        elevate: !_vm.lower
    }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }